import { getResponsiveProp, responsive } from '../helpers';
export function gridItemStyle() {
  return [responsiveGridItemRowStyle, responsiveGridItemRowStartStyle, responsiveGridItemRowEndStyle, responsiveGridItemColumnStyle, responsiveGridItemColumnStartStyle, responsiveGridItemColumnEndStyle];
}
var GRID_ITEM_ROW = {
  auto: 'auto',
  full: '1 / -1'
};
var GRID_ITEM_COLUMN = {
  auto: 'auto',
  full: '1 / -1'
};

function responsiveGridItemRowStyle(_ref) {
  var row = _ref.row,
      theme = _ref.theme;
  return responsive(theme.sanity.media, getResponsiveProp(row).map(function (val) {
    if (typeof val === 'number') {
      return {
        gridRow: "span ".concat(val, " / span ").concat(val)
      };
    }

    return {
      gridRow: GRID_ITEM_ROW[val]
    };
  }));
}

function responsiveGridItemRowStartStyle(_ref2) {
  var rowStart = _ref2.rowStart,
      theme = _ref2.theme;
  return responsive(theme.sanity.media, getResponsiveProp(rowStart).map(function (val) {
    return {
      gridRowStart: val
    };
  }));
}

function responsiveGridItemRowEndStyle(_ref3) {
  var rowEnd = _ref3.rowEnd,
      theme = _ref3.theme;
  return responsive(theme.sanity.media, getResponsiveProp(rowEnd).map(function (val) {
    return {
      gridRowEnd: val
    };
  }));
}

function responsiveGridItemColumnStyle(_ref4) {
  var column = _ref4.column,
      theme = _ref4.theme;
  return responsive(theme.sanity.media, getResponsiveProp(column).map(function (val) {
    if (typeof val === 'number') {
      return {
        gridColumn: "span ".concat(val, " / span ").concat(val)
      };
    }

    return {
      gridColumn: GRID_ITEM_COLUMN[val]
    };
  }));
}

function responsiveGridItemColumnStartStyle(_ref5) {
  var columnStart = _ref5.columnStart,
      theme = _ref5.theme;
  return responsive(theme.sanity.media, getResponsiveProp(columnStart).map(function (val) {
    return {
      gridColumnStart: val
    };
  }));
}

function responsiveGridItemColumnEndStyle(_ref6) {
  var columnEnd = _ref6.columnEnd,
      theme = _ref6.theme;
  return responsive(theme.sanity.media, getResponsiveProp(columnEnd).map(function (val) {
    return {
      gridColumnEnd: val
    };
  }));
}